import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
export default function TheDifference() {
  return (

    <div className='w-full bg-[#2f8ab9] flex flex-col justify-center items-center'>
    
    <div className=" w-full py-14 md:py-24 relative bg-[#2f8ab9] flex flex-col justify-start items-center gap-16">
      {/* Background arrows - hidden on mobile */}
   
      <div className="hidden lg:block absolute right-0 top-1/2 transform -translate-y-1/2">
        <img 
          src="/static/images/cka_landing/arrows2.png" 
          alt="Background arrows" 
          width={300} 
          height={300}
          className="object-contain"
          style={{marginRight:-20, }}
        />
      </div>
      <div className="hidden lg:block absolute left-0 top-1/2 transform -translate-y-1/2 scale-x-[-1]">
        <img 
          src="/static/images/cka_landing/arrows2.png" 
          alt="Background arrows" 
          width={300} 
          height={300}
          className="object-contain"
          style={{marginRight:-20, }}
        />
      </div>
      <div className="mx-auto max-w-7xl w-full px-4 lg:px-32 flex flex-col justify-start items-start gap-4">
        <div className="w-full inline-flex justify-center items-center">
          <div className="inline-flex flex-col justify-start items-center gap-3">
        
            <div className="flex flex-col justify-start items-center gap-2">
              <div className="inline-flex justify-start items-start gap-1">
                <div className="w-full max-w-4xl text-center">
                  <span className="text-white text-2xl lg:text-4xl font-medium font-['Lora']">
                    The Difference Between a Financial Advisor{' '}
                  </span>
                  <span className="text-white text-2xl lg:text-4xl font-medium font-['Lora'] italic">
                    Who&apos;s a Christian
                  </span>
                  <span className="text-white text-2xl lg:text-4xl font-medium font-['Lora']">
                    {' '}and a{' '}
                  </span>
                  <span className="text-white text-2xl lg:text-4xl font-medium font-['Lora'] italic">
                    Christian Financial Advisor
                  </span>
                  <span className="text-white text-2xl lg:text-4xl font-medium font-['Lora']">
                    {' '}Is a Crucial Designation
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="w-full px-4 lg:px-32 inline-flex justify-center items-center">
          <div className="flex-1 text-center">
            <span className="text-white text-base lg:text-lg font-normal font-['Instrument-Sans'] leading-7">
              Join thousands of advisors who are fully integrating biblical wisdom and financial advice through a model{' '}
            </span>
            <span className="text-white text-base lg:text-lg font-bold font-['Instrument-Sans'] leading-7">
              that&apos;s been professionally proven over decades.
            </span>
          </div>
        </div>
      </div>
      <div className='w-full px-4 flex justify-center items-center'>
      <Link className='w-full md:w-auto' href="https://app.kingdomadvisors.com/cka" target='_blank' rel='noopener noreferrer'>
      <div className="w-full md:w-auto px-8 py-4 bg-[#192f5c] rounded inline-flex justify-center items-center gap-2.5 hover:bg-[#192f5c] transition-colors cursor-pointer">
        <div className="w-6 h-6 relative">
          <Image 
            src="/static/images/cka_landing/yellow arrows.svg" 
            alt="Arrow" 
            width={24} 
            height={24}
          />
        </div>
        <div className="justify-start text-white text-base font-medium font-['Instrument-Sans']">
          Get Certified
        </div>
      </div>
      </Link>
      </div>

    </div>
    
    </div>
    
  )
}